<template>
    <div></div>
</template>

<script>

    export default {
        name: "commercial-options",
        props: {},
        data() {
            return {

            }
        },

        created() {
            this.$store.commit('endProgress')
        },
    }
</script>

<style scoped>

</style>